export const categories = [
  {
    slug: 'whisper',
    name: '轻声耳语',
    description: '温柔的低语与耳边轻语，带来极致亲密感与安全感，仿佛有人在身边轻声安抚。',
    icon: 'ri-mic-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20gentle%20whispering%20scene%20with%20warm%20candlelight%2C%20cozy%20bedroom%20atmosphere%2C%20soft%20wool%20blanket%20texture%2C%20golden%20hour%20lighting%2C%20intimate%20and%20calming%20mood%2C%20minimalist%20aesthetic%2C%20cream%20and%20beige%20color%20palette%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=cat-whisper-01&orientation=landscape',
    articleCount: 42,
    color: 'amber',
  },
  {
    slug: 'nature',
    name: '自然音效',
    description: '雨声、海浪、森林鸟鸣等大自然原声，带你逃离城市喧嚣，回归内心宁静。',
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=Peaceful%20forest%20scene%20with%20soft%20morning%20light%20filtering%20through%20trees%2C%20gentle%20stream%20flowing%2C%20moss%20covered%20rocks%2C%20misty%20atmosphere%2C%20calming%20green%20and%20earth%20tones%2C%20zen%20like%20natural%20landscape%2C%20minimalist%20nature%20photography&width=800&height=600&seq=cat-nature-01&orientation=landscape',
    articleCount: 56,
    color: 'green',
  },
  {
    slug: 'roleplay',
    name: '角色扮演',
    description: '理发店、SPA、医疗检查等沉浸式情景模拟，让你身临其境感受专业服务体验。',
    icon: 'ri-user-voice-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20minimalist%20spa%20room%20with%20warm%20lighting%2C%20white%20towels%2C%20aromatherapy%20diffuser%2C%20bamboo%20decor%2C%20calming%20serene%20atmosphere%2C%20cream%20and%20warm%20beige%20tones%2C%20professional%20yet%20cozy%20setting&width=800&height=600&seq=cat-roleplay-01&orientation=landscape',
    articleCount: 38,
    color: 'rose',
  },
  {
    slug: 'tapping',
    name: '敲击触发',
    description: '指尖敲击、物品触碰等ASMR经典触发音，节奏感与质感兼具的听觉享受。',
    icon: 'ri-knife-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20closeup%20of%20wooden%20surface%20with%20gentle%20fingertip%20touch%2C%20warm%20natural%20textures%2C%20minimalist%20product%20photography%2C%20soft%20diffused%20lighting%2C%20cream%20and%20wood%20tones%2C%20calming%20sensory%20aesthetic&width=800&height=600&seq=cat-tapping-01&orientation=landscape',
    articleCount: 29,
    color: 'orange',
  },
  {
    slug: 'eating',
    name: '美食咀嚼',
    description: '酥脆炸鸡、Q弹果冻等让人满足的美食咀嚼音，食欲与听觉的双重治愈。',
    icon: 'ri-cake-line',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20minimalist%20food%20photography%20with%20soft%20natural%20light%2C%20artisan%20pastry%20on%20ceramic%20plate%2C%20warm%20bakery%20atmosphere%2C%20cream%20and%20golden%20brown%20tones%2C%20cozy%20cafe%20vibe%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=cat-eating-01&orientation=landscape',
    articleCount: 24,
    color: 'yellow',
  },
  {
    slug: 'visual',
    name: '视觉触发',
    description: '舒缓的手部动作、灯光变化等视觉ASMR内容，用画面引导你进入放松状态。',
    icon: 'ri-eye-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20gentle%20hands%20moving%20slowly%20in%20warm%20light%2C%20minimalist%20studio%20setting%2C%20calming%20visual%20triggers%2C%20cream%20and%20soft%20beige%20background%2C%20therapeutic%20sensory%20aesthetic%2C%20shallow%20depth%20of%20field&width=800&height=600&seq=cat-visual-01&orientation=landscape',
    articleCount: 31,
    color: 'purple',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};